import React, { useState } from "react";
import { Modal } from "../ui";
import "./Footer.css";

const CGV_CONTENT = `
## Conditions Générales de Vente – Celeste Favaro

**Dernière mise à jour : 2025**

### Mentions légales

Vendeur : Madame Celeste Favaro, entreprise individuelle
SIREN : 909 374 258
Adresse : 06130 Grasse, France
Activité : Édition de livres (entreprise active depuis le 22 janvier 2022)
Email : blufavaro@gmail.com
Site : celestefavaro.fr

### 1. Objet
Les présentes conditions générales de vente régissent les relations contractuelles entre Madame Celeste Favaro, entreprise individuelle immatriculée sous le numéro SIREN 909 374 258, dont le siège est situé à 06130 Grasse (ci-après « le vendeur »), et tout acheteur (ci-après « le client ») souhaitant procéder à un achat sur le site celestefavaro.fr.

### 2. Produits
Les produits proposés sont des livrets format A5 physiques relevant de l'activité d'édition de livres. Les caractéristiques essentielles des produits sont décrites sur le site. Le vendeur se réserve le droit de modifier à tout moment l'assortiment de produits.

### 3. Prix
Les prix sont indiqués en euros toutes taxes comprises (TTC). Les frais de livraison sont indiqués et facturés en sus.

### 4. Commande
Toute commande implique l'acceptation des présentes CGV. Le contrat est conclu lorsque le client a validé sa commande et effectué le paiement.

### 5. Paiement
Le paiement s'effectue en ligne par carte bancaire via la plateforme sécurisée Square. Les données bancaires du client sont cryptées et ne sont pas stockées par le vendeur.

### 6. Livraison
Les commandes sont expédiées en France métropolitaine par courrier postal depuis Grasse (06130). Les délais de livraison sont indicatifs et peuvent varier en fonction des délais postaux. En cas de retard de livraison, le client peut contacter le vendeur à l'adresse email indiquée.

### 7. Droit de rétractation
Conformément aux articles L.221-18 et suivants du Code de la consommation, le client dispose d'un délai de 14 jours à compter de la réception de sa commande pour exercer son droit de rétractation, sans avoir à justifier de motifs ni à payer de pénalité. Pour exercer ce droit, le client doit contacter le vendeur par email à blufavaro@gmail.com.

### 8. Retours
Les produits doivent être retournés dans leur état d'origine, non utilisés. Les frais de retour sont à la charge du client.

### 9. Données personnelles
Les données personnelles collectées sont utilisées uniquement pour le traitement des commandes et ne sont pas transmises à des tiers, sauf nécessité liée au traitement de la commande (transporteur). Conformément au RGPD, le client dispose d'un droit d'accès, de rectification et de suppression de ses données en contactant le vendeur à blufavaro@gmail.com.

### 10. Propriété intellectuelle
Le contenu des livrets (textes, illustrations) est la propriété exclusive de Celeste Favaro et est protégé par le droit d'auteur. Toute reproduction, même partielle, est interdite sans autorisation écrite préalable.

### 11. Droit applicable
Les présentes CGV sont soumises au droit français. En cas de litige, les parties s'efforceront de trouver une solution amiable. À défaut, les tribunaux compétents du ressort de Grasse seront saisis.

### Contact
Madame Celeste Favaro – blufavaro@gmail.com – 06130 Grasse
`;

const Footer: React.FC = () => {
  const [cgvOpen, setCgvOpen] = useState(false);


  const scrollToSection = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };


  return (
    <>
      <footer className="footer">
        <div className="footer__inner">
          <div className="footer__links">
            <button className="footer__link" onClick={() => setCgvOpen(true)}>
              Conditions Générales de Vente
            </button>
            <span className="footer__sep">·</span>
            <a className="footer__link" onClick={() => scrollToSection("contact")}>Contact</a>
            <span className="footer__sep">·</span>
            <a
              className="footer__link"
              href="https://www.youtube.com/channel/UCa5UWRmFQNDnE07oOqcS2Wg"
              target="_blank"
              rel="noopener noreferrer"
            >
              YouTube
            </a>
          </div>

          <p className="footer__copy">© {new Date().getFullYear()} Celeste Favaro. Tous droits réservés.</p>
        </div>
      </footer>

      <Modal isOpen={cgvOpen} onClose={() => setCgvOpen(false)} title="Conditions Générales de Vente" size="lg">
        <div className="cgv">
          {CGV_CONTENT.split("\n").map((line, i) => {
            if (line.startsWith("## ")) return <h2 key={i}>{line.replace("## ", "")}</h2>;
            if (line.startsWith("### ")) return <h3 key={i}>{line.replace("### ", "")}</h3>;
            if (line.startsWith("**") && line.endsWith("**")) return <p key={i}><strong>{line.replace(/\*\*/g, "")}</strong></p>;
            if (line.trim() === "") return <br key={i} />;
            return <p key={i}>{line.replace(/\*\*/g, "")}</p>;
          })}
        </div>
      </Modal>
    </>
  );
};

export default Footer;
